import { CuredApiPaths } from 'models/enums';
import { Campaign } from 'domains/campaigns/types';
import { UseQueryOptions } from 'react-query';
import useQuery from '../useQuery';
import QueryKeys from './keys';

type UseCampaignsOptions = {
    searchTerm?: string;
    reactQueryOptions?: UseQueryOptions<Campaign[], Error>;
};

const useCampaigns = (options: UseCampaignsOptions = {}) => {
    const { searchTerm, reactQueryOptions } = options;

    const axiosOptions = searchTerm ? { params: { searchTerm: searchTerm } } : {};

    return useQuery([QueryKeys.CAMPAIGNS, { searchTerm }], CuredApiPaths.CAMPAIGNS, reactQueryOptions, axiosOptions);
};

export default useCampaigns;
